const Settings = {
    "language": "en"
}

export default Settings;